var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":_vm.size,"color":"primary"}},[(_vm.src)?_c('v-img',{attrs:{"src":_vm.src,"alt":_vm.alt}}):_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-account")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }